export default __webpack_public_path__ + "static/media/Tonado.83799022.svg";